const menus = [
//   {
//     id: 'corderlist',
//     icon: 'fa fa-pagelines',
//     label: '我的工单',
//     submenu: [
//       {id: 'ordertpl', path: '/ordertpl/list', label: '新建工单'},
//       {id: 'suborder', path: '/submitted/order', label: '工单状态'},
//     ]
// },
//   {
//     id: 'monitor-manage',
//     icon: 'fa fa-cogs',
//     label: '监控管理',
//     submenu: [
//       {id: 'monitor-list', path: '/monitor/list/', label: '监控展示'},
//     ]
//   },
  {
    id: 'meeting-manage',
    icon: 'fa fa-meetup',
    label: '会议室',
    submenu: [
      {id: 'meeting-order', path: '/meeting/order', label: '会议室预定'},
      // {id: 'mb-meeting-order', path: '/mb/meeting/order', label: '移动会议室预定'},
    ]
  }
]
export default menus



// WEBPACK FOOTER //
// ./src/views/layout/menus.js